import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../../services/auth.service';

export const authGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  // Esperamos a que loadProfileOnInit termine
  if (!auth.profileLoaded()) {
    await auth.loadProfileOnInit();
  }

  // Si no hay usuario -> login
  if (!auth.currentUser()) {
    router.navigate(['/auth/login']);
    return false;
  }

  return true;
};
